import React from 'react';
import { useGetExamChargesContext } from '../context';
import TopHeader from '../../collectPayment/header';
import StepperWrapper from './components/StepperWrapper';
import SelectPaymentModeWrapper from './components/SelectPaymentModeWrapper';
import ReviewAndReceipt from './components/ReviewAndReceipt';
import { getHeaderItems } from './utils';

export const pageStateMapping = {
  SELECT_PAYMENT_MODE: <SelectPaymentModeWrapper module={'ExamCharges'} />,
  REVIEW: <ReviewAndReceipt module={'ExamCharges'} />,
};

const GetPageComponentByState = () => {
  const {
    currentPageState
  } = useGetExamChargesContext();

  return (
    pageStateMapping[currentPageState] || null
  )
}


const ExamChargesCollection = () => {
  const { setOnPaymentCollectionStep, setCurrentStep, setCurrentPageState } = useGetExamChargesContext();

  const backButtonClickHandler = () => {
    setOnPaymentCollectionStep(false);
    setCurrentStep(0);
    setCurrentPageState(Object.keys(pageStateMapping)[0]);
  }

  return (

    <div className="remove-container-top-space">
      <TopHeader module={'ExamCharges'} backIconClickHandler={backButtonClickHandler} getHeaderChips={getHeaderItems} />
      <div className="p-2 m-2">
        <StepperWrapper />
        {/* <TopStripAlert /> */}
        <GetPageComponentByState />
      </div>
    </div>

  );
}

export default ExamChargesCollection;